import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Scale } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function BalanceCheckCard() {
  const { can } = useAuth();
  const nav = useNavigate();
  const [s, setS] = useState(null);
  const ok = can("finans", "edit");
  useEffect(() => { if (ok) api.get("/balance-check/status").then(({ data }) => setS(data)).catch(() => {}); }, [ok]);
  if (!s || s.done || !s.enabled) return null;
  return (
    <button onClick={() => nav("/bakiye-kontrol")} className="w-full mb-4 flex items-center gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-left hover:bg-amber-100 transition-colors" data-testid="dashboard-balance-check-card">
      <Scale className="h-5 w-5 text-amber-700" />
      <div><div className="font-semibold text-amber-900 text-sm">Bu ayın bakiye kontrolü yapılmadı</div>
        <div className="text-[12px] text-amber-800">{s.month} · kasa ve banka bakiyelerini gerçek bakiyelerle karşılaştırın</div></div>
    </button>
  );
}
